import { cloneElement, useId } from 'react';
import { cn } from '../../lib/cn';

// Etykieta + pole + komunikat błędu/podpowiedzi jako jeden komponent.
//
// Zastępuje ~20 powtórzeń tej samej trójki elementów w formularzach. Poza
// skróceniem kodu daje coś, czego poprzednia wersja nie miała: identyfikatory
// są generowane automatycznie (koniec z ręcznym pilnowaniem zgodności htmlFor
// z id), a komunikat błędu jest powiązany z polem przez aria-describedby
// i oznaczony jako role="alert", więc czytnik ekranu go odczyta.

export function Field({
  label,
  error,
  hint,
  required = false,
  children,
  className,
  labelClassName,
}) {
  const generatedId = useId();
  const fieldId = children.props.id || generatedId;
  const errorId = `${fieldId}-error`;
  const hintId = `${fieldId}-hint`;

  const describedBy = cn(error && errorId, !error && hint && hintId) || undefined;

  const control = cloneElement(children, {
    id: fieldId,
    invalid: Boolean(error) || children.props.invalid,
    'aria-describedby': describedBy,
  });

  return (
    <div className={cn('min-w-0', className)}>
      {label && (
        <label
          htmlFor={fieldId}
          className={cn('mb-1.5 block text-xs font-medium text-muted', labelClassName)}
        >
          {label}
          {required && <span className="ml-0.5 text-danger">*</span>}
        </label>
      )}

      {control}

      {error && (
        <p id={errorId} role="alert" className="mt-1 text-xs text-danger">
          {error}
        </p>
      )}
      {!error && hint && (
        <p id={hintId} className="mt-1 text-xs text-subtle">
          {hint}
        </p>
      )}
    </div>
  );
}

export default Field;
